import { useState, useEffect } from "react";
import axiosNew from "../store/api/axiosNew";

export default function useBusinessDashboardApi() {
  const [allLeads, setAllLeads] = useState([]);
  const [myRetailLeads, setMyRetailLeads] = useState([]);
  const [pagination, setPagination] = useState({});
  const [retailPagination, setRetailPagination] = useState({});
  const [cartLeads, setCartLeads] = useState(() => {
    const stored = localStorage.getItem("dashboard_cart");

    if (stored) return JSON.parse(stored);

    // fallback for guest cart
    const guestCart = JSON.parse(localStorage.getItem("guestCart") || "[]");
    return guestCart;
  });

  const [loading, setLoading] = useState(false);
  console.log(" useBusinessDashboardApi mounted");

  /* ================= LEADS ================= */
  useEffect(() => {
    localStorage.setItem("dashboard_cart", JSON.stringify(cartLeads));
  }, [cartLeads]);

  const fetchAllLeads = async (page = 1, params = {}) => {
    setLoading(true);
    try {
      const res = await axiosNew.get("admin/all-leads", {
        params: {
          page,
          limit: 10,
          ...params,
        },
      });
      setAllLeads(res?.data?.data || []);
      setPagination(res?.data?.pagination || {});
    } catch (err) {
      console.error("Fetch leads failed", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMyRetailLeads = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axiosNew.get("/admin/all-leads", {
        params: {
          page,
          userDataOnly: true,
        },
      });

      setMyRetailLeads(res?.data?.data || []);
      setRetailPagination(res?.data?.pagination || {});
    } catch (err) {
      console.error("Fetch my retail leads failed", err);
    } finally {
      setLoading(false);
    }
  };

  const updateLeadStatus = async (leadId, status, extraData = {}) => {
    const token = localStorage.getItem("accessToken");
    try {
      await axiosNew.put(
        `https://apilead.blaccdot.com/api/admin/leads/${leadId}/`,
        // { user_status: status },
        { user_status: status, ...extraData },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setMyRetailLeads((prev) =>
        prev.map((l) => (l._id === leadId ? { ...l, user_status: status } : l)),
      );
    } catch (err) {
      console.error("Update lead status failed", err);
    }
  };

  const updateLeadCategory = async (
    leadId,
    subCategoryName,
    subCategoryLabel,
  ) => {
    const token = localStorage.getItem("accessToken");

    try {
      await axiosNew.put(
        `/admin/leads/${leadId}/`,
        { subcategory: subCategoryName },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ✅ Optimistic UI update
      setAllLeads((prev) =>
        prev.map((l) =>
          l._id === leadId
            ? {
                ...l,
                subcategory: {
                  ...l.subcategory,
                  name: subCategoryName, // "villa"
                  label: subCategoryLabel, // "Villa"
                },
              }
            : l,
        ),
      );
    } catch (err) {
      console.error("Update subcategory failed", err);
    }
  };

  // const fetchCart = async () => {
  //   const token = localStorage.getItem("accessToken");
  //   const userId = localStorage.getItem("userId");

  //   const guestCart = JSON.parse(localStorage.getItem("guestCart") || "[]");

  //   // ---------- GUEST USER ----------
  //   if (!token || !userId) {
  //     setCartLeads(guestCart);
  //     return;
  //   }

  //   try {
  //     // 1️⃣ Fetch server cart
  //     const res = await axiosNew.get(
  //       `https://apilead.blaccdot.com/api/cart/${userId}`,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );

  //     const serverItems = res.data?.cart?.items || [];

  //     const serverCart = serverItems.map((i) => ({
  //       id: i.lead?._id || i.leadId,
  //       name: i.lead?.name,
  //       place: i.lead?.location,
  //       price: i.price,
  //       quantity: i.quantity,
  //     }));

  //     // 2️⃣ Merge guest cart → backend
  //     if (guestCart.length) {
  //       await Promise.all(
  //         guestCart.map((gLead) => {
  //           const exists = serverCart.some(
  //             (sLead) => sLead.id === gLead.id
  //           );

  //           if (!exists) {
  //             return axiosNew.post(
  //               "https://apilead.blaccdot.com/api/cart/add/",
  //               { leadId: gLead.id },
  //               { headers: { Authorization: `Bearer ${token}` } }
  //             );
  //           }
  //         })
  //       );
  //     }

  //     // 3️⃣ Fetch server cart AGAIN (source of truth)
  //     const refreshed = await axiosNew.get(
  //       `https://apilead.blaccdot.com/api/cart/${userId}`,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );

  //     const finalCart =
  //       refreshed.data?.cart?.items?.map((i) => ({
  //         id: i.lead?._id || i.leadId,
  //         name: i.lead?.name,
  //         place: i.lead?.location,
  //         price: i.price,
  //         quantity: i.quantity,
  //       })) || [];

  //     // 4️⃣ Update UI + storage
  //     setCartLeads(finalCart);
  //     localStorage.setItem("dashboard_cart", JSON.stringify(finalCart));

  //     // 5️⃣ NOW safely remove guest cart
  //     localStorage.removeItem("guestCart");
  //   } catch (err) {
  //     console.error("Fetch cart failed", err);
  //   }
  // };

  const fetchCart = async () => {
    const token = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");
    const GUEST_MERGED_KEY = "guestCartMerged";

    const guestCart = JSON.parse(localStorage.getItem("guestCart") || "[]");
    const alreadyMerged = localStorage.getItem(GUEST_MERGED_KEY);

    // ---------- GUEST USER ----------
    if (!token || !userId) {
      setCartLeads(guestCart);
      return;
    }

    try {
      // 1️⃣ Fetch server cart FIRST (source of truth)
      const serverRes = await axiosNew.get(
        `https://apilead.blaccdot.com/api/cart/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const serverItems = serverRes.data?.cart?.items || [];

      // Build a Set of existing lead IDs on server
      const serverLeadIds = new Set(
        serverItems.map((i) => i.lead?._id || i.leadId),
      );

      // 2️⃣ Merge guest cart → backend ONLY if missing
      // 🔒 Merge guest cart ONLY ONCE
      if (guestCart.length && !alreadyMerged) {
        // await Promise.all(
        //   guestCart.map((gLead) => {
        //     if (!serverLeadIds.has(gLead.id)) {
        //       return axiosNew.post(
        //         "https://apilead.blaccdot.com/api/cart/add/",
        //         { leadId: gLead.id },
        //         { headers: { Authorization: `Bearer ${token}` } }
        //       );
        //     }
        //   })
        // );

        const leadsToMerge = guestCart.filter(
          (gLead) => !serverLeadIds.has(gLead.id),
        );

        await Promise.all(
          leadsToMerge.map((gLead) =>
            axiosNew.post(
              "https://apilead.blaccdot.com/api/cart/add/",
              { leadId: gLead.id },
              { headers: { Authorization: `Bearer ${token}` } },
            ),
          ),
        );

        // mark merge done
        localStorage.setItem(GUEST_MERGED_KEY, "true");
      }

      // 3️⃣ Fetch server cart AGAIN (final truth)
      const finalRes = await axiosNew.get(
        `https://apilead.blaccdot.com/api/cart/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // const dedupeById = (items) => {
      //   const map = new Map();
      //   items.forEach((i) => map.set(i.id, i));
      //   return Array.from(map.values());
      // };

      const finalCart =
        finalRes.data?.cart?.items?.map((i) => ({
          id: i.lead?._id || i.leadId,
          name: i.lead?.name,
          place: i.lead?.location,
          price: i.price,
          quantity: i.quantity,
        })) || [];

      // 4️⃣ Update UI + storage
      setCartLeads(finalCart);
      // setCartLeads((prev) => dedupeById([...prev, ...finalCart]));

      localStorage.setItem("dashboard_cart", JSON.stringify(finalCart));

      // 5️⃣ Remove guest cart ONLY after successful merge
      localStorage.removeItem("guestCart");
    } catch (err) {
      console.error("Fetch cart failed", err);
    }
  };

  const addLeadToCart = async (lead) => {
    const leadForCart = {
      id: lead.id,
      name: lead.name,
      place: lead.place,
      price: lead.price,
      quantity: lead.quantity || 1,
    };

    const token = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");

    //  Guest user
    if (!token || !userId) {
      const guestCart = JSON.parse(localStorage.getItem("guestCart") || "[]");
      if (!guestCart.some((l) => l.id === leadForCart.id)) {
        const updatedCart = [...guestCart, leadForCart];
        localStorage.setItem("guestCart", JSON.stringify(updatedCart));
        setCartLeads(updatedCart);
      }
      return;
    }

    //  Logged-in user
    //  Optimistic update
    setCartLeads((prev) =>
      prev.some((l) => l.id === leadForCart.id) ? prev : [...prev, leadForCart],
    );

    try {
      const res = await axiosNew.post(
        "https://apilead.blaccdot.com/api/cart/add/",
        { leadId: lead.id },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (res.data?.cart?.userId) {
        localStorage.setItem("cartUserId", res.data.cart.userId);
      }
      console.log("here", res?.cart?.userId);
      // No need to call fetchCart here immediately — backend will eventually sync
    } catch (err) {
      console.error("Add to cart failed", err);
      // Rollback optimistic update
      setCartLeads((prev) => prev.filter((l) => l.id !== leadForCart.id));
    }
  };

  /* ---------- REMOVE FROM CART ---------- */
  const removeLeadFromCart = async (leadId) => {
    const token = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");
    const cartUserId = localStorage.getItem("cartUserId");

    //  Optimistic removal
    setCartLeads((prev) => prev.filter((l) => l.id !== leadId));

    //  Guest user
    if (!token || !userId) {
      const guestCart = JSON.parse(localStorage.getItem("guestCart") || "[]");
      const updatedCart = guestCart.filter((l) => l.id !== leadId);
      localStorage.setItem("guestCart", JSON.stringify(updatedCart));
      return;
    }

    //  Logged-in user
    try {
      await axiosNew.delete(
        `https://apilead.blaccdot.com/api/cart/${userId}/${leadId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      // Don't fetchCart immediately — keep optimistic UI
    } catch (err) {
      console.error("Remove from cart failed", err);
      // Rollback optimistic update
      // Optional: you could refetch backend if necessary
    }
  };

  /* ================= INIT ================= */

  useEffect(() => {
    fetchAllLeads(1);
    fetchMyRetailLeads(1);
    fetchCart();
  }, []);

  return {
    allLeads,
    pagination,
    myRetailLeads,
    retailPagination,
    cartLeads,
    loading,
    fetchAllLeads,
    fetchMyRetailLeads,
    updateLeadStatus,
    updateLeadCategory,
    addLeadToCart,
    removeLeadFromCart,
  };
}
